import {
  isBillingBypassedForSuperAdmin,
  isBillingEnforcedRole,
  shouldRequireBillingAccess,
} from "./billingAccess";
import { isOnboardingComplete } from "./onboarding";

export const BILLING_AND_REGISTRATION_GATE_MESSAGE =
  "Your 30-day free trial has ended. Add billing information to continue using Ellyanna.";

export const SALON_BILLING_LOCK_MESSAGE =
  "This salon's 30-day free trial has ended. Ask the salon owner or admin to add billing information to continue using Ellyanna.";

export const REGISTRATION_GATE_MESSAGE =
  "Complete the required registration process to unlock Ellyanna. Finish the Salon / Independent Professionals Setup Wizard to continue.";

function getDefaultSetupDestination(role) {
  return String(role || "").toLowerCase() === "independent_professional"
    ? "/setup?mode=independent_professional"
    : "/setup";
}

export function shouldRequireSetupCompletion(role, user, options = {}) {
  const normalizedRole = String(role || user?.role || "").toLowerCase();
  const onboardingCompleted =
    options.onboardingCompleted === undefined
      ? isOnboardingComplete()
      : Boolean(options.onboardingCompleted);

  return (
    !shouldRequireBillingAccess(normalizedRole, user) &&
    !isBillingBypassedForSuperAdmin(user) &&
    isBillingEnforcedRole(normalizedRole) &&
    !onboardingCompleted
  );
}

export function getEllyannaAccessGate(role, user, options = {}) {
  const normalizedRole = String(role || user?.role || "").toLowerCase();
  const setupDestination =
    options.setupDestination || getDefaultSetupDestination(normalizedRole);
  const nextAfterBilling = options.nextAfterBilling || setupDestination;

  if (shouldRequireBillingAccess(normalizedRole, user)) {
    return {
      stage: "billing",
      title: "Add billing information",
      message: BILLING_AND_REGISTRATION_GATE_MESSAGE,
      destination:
        options.billingDestination ||
        `/manager/manage/billing/replace-card?onboarding=1&next=${encodeURIComponent(
          nextAfterBilling
        )}`,
      ctaLabel: "Add Billing Info",
    };
  }

  if (
    !isBillingBypassedForSuperAdmin(user) &&
    !isBillingEnforcedRole(normalizedRole) &&
    user?.billing_access_granted === false
  ) {
    return {
      stage: "salon_billing_locked",
      title: "Salon access paused",
      message: SALON_BILLING_LOCK_MESSAGE,
      ctaLabel: "Contact Salon Owner",
    };
  }

  if (shouldRequireSetupCompletion(normalizedRole, user, options)) {
    return {
      stage: "setup",
      title: "Complete registration",
      message: REGISTRATION_GATE_MESSAGE,
      destination: setupDestination,
      ctaLabel: "Continue Setup",
    };
  }

  return null;
}

export function isGateAllowedPath(path, stage) {
  const normalizedPath = String(path || "");
  if (!normalizedPath) return false;
  if (stage === "billing") {
    return normalizedPath.startsWith("/manager/manage/billing");
  }
  if (stage === "setup") {
    return (
      normalizedPath.startsWith("/setup") ||
      normalizedPath.startsWith("/manager/manage/billing")
    );
  }
  return true;
}
